export default function CvSkillTags({ skills = [] }) { return skills.length ? <div className="cv-skill-tags">{skills.map((skill) => <span className="cv-skill-tag" key={skill.id || skill.name}>{skill.name}</span>)}</div> : null; }
